import { Icon } from '@iconify/react';
import { Button, Link } from '@nextui-org/react';
import { useLocation, useNavigate } from 'react-router-dom';

const CheckEmailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || 'your email';

  const handleResendEmail = () => {
    navigate('/forgot-password', { replace: true });
  };

  return (
    <div className="flex h-full w-full items-center justify-center px-8 pt-20">
      <div className="flex w-full max-w-sm flex-col gap-4 rounded-large">
        <div className="flex flex-col items-center pb-6">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Icon
              icon="solar:letter-linear"
              className="text-2xl text-primary"
            />
          </div>
          <p className="text-xl font-medium">Check your email</p>
          <p className="text-small text-default-500 text-center">
            We've sent a password reset link to <strong>{email}</strong>
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <div className="rounded-lg bg-default-50 p-4">
            <p className="text-small text-default-600">
              Didn't receive the email? Check your spam folder or try a
              different email address.
            </p>
          </div>

          <Button
            color="primary"
            variant="bordered"
            onClick={handleResendEmail}
          >
            Resend Email
          </Button>

          <Button color="primary" onClick={() => navigate('/login')}>
            Back to Login
          </Button>
        </div>

        <div className="flex items-center justify-center">
          <Link className="text-default-500" href="/forgot-password" size="sm">
            Use a different email address
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckEmailPage;
